import { render, staticRenderFns } from "./messageParTagChart.vue?vue&type=template&id=2898df23&"
import script from "./messageParTagChart.vue?vue&type=script&lang=js&"
export * from "./messageParTagChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports